class LaravelErrors {
  static getFirstErrorOnly (laravelErrors) {
    const errors = {};
    Object.keys(laravelErrors).forEach((key) => {
      errors[key] = laravelErrors[key][0];
    });
    return errors;
  }

  static fromErrorObject(error){
      if (error.response && error.response.status === 422 && error.response.data && error.response.data.errors) {
          return  LaravelErrors.getFirstErrorOnly(error.response.data.errors);
      }
      return null;
  }
}

export default LaravelErrors;
